import forge from 'node-forge';

function generateAESKey() {
  return forge.random.getBytesSync(32);
}

function encryptWithAES(password: string, aesKey: string) {
  const iv = forge.random.getBytesSync(12);
  const cipher = forge.cipher.createCipher('AES-GCM', aesKey);
  cipher.start({ iv });
  cipher.update(forge.util.createBuffer(password));
  cipher.finish();

  return {
    encryptPassword: forge.util.encode64(cipher.output.getBytes()),
    iv: forge.util.encode64(iv),
    authTag: forge.util.encode64(cipher.mode.tag.getBytes()),
  };
}

export function encryptAESKeyWithRSA(aesKey: string, publicKey: string) {
  const rsa = forge.pki.publicKeyFromPem(publicKey);
  return forge.util.encode64(rsa.encrypt(aesKey, 'RSA-OAEP'));
}

export async function encryptPasswordBeforeSending(password: string, publicKey: string | undefined) {
  if (!publicKey) throw new Error('Public key is required for encryption');

  const aesKey = generateAESKey();
  const { encryptPassword, iv, authTag } = encryptWithAES(password, aesKey);
  const encryptedAESKey = encryptAESKeyWithRSA(aesKey, publicKey);

  return { encryptPassword, encryptedAESKey, iv, authTag };
}
